<template>
  <ion-page>
    <ion-content class="h-full">
      <round-header
        image-type="component"
        :image="PersonStanding"
        title="Friends"
        disable-edit-mode="true"
      >
      </round-header>
      <div class="flex w-full justify-center">
        <FriendsList
          :friends="profileRef?.value?.sharedWith ?? []"
          :on-added="addFriend"
          :on-removed="removeFriend"
        />
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { PersonStanding } from 'lucide-vue-next';
import { IonContent, IonPage } from '@ionic/vue';
import RoundHeader from '../components/RoundHeader.vue';
import FriendsList from '../components/FriendsList.vue';
import { arrayUnion, arrayRemove, doc, getFirestore, updateDoc } from 'firebase/firestore';
import { profileRef } from '../services/FirebaseDB.ts';
import { useCurrentUser } from 'vuefire';

const db = getFirestore();
const user = useCurrentUser();

async function addFriend(id: string) {
  if (user.value == null) {
    return;
  }
  const profileDoc = doc(db, `users/${user.value.uid}/profile/default`);
  await updateDoc(profileDoc, {
    lastModified: Date.now(),
    sharedWith: arrayUnion(id),
  });
  console.log('Added friend!');
}

async function removeFriend(id: string) {
  if (user.value == null) {
    return;
  }
  const profileRef = doc(db, `users/${user.value.uid}/profile/default`);
  await updateDoc(profileRef, {
    lastModified: Date.now(),
    sharedWith: arrayRemove(id),
  });
  console.log('Removed friend!');
}
</script>
